export default __webpack_public_path__ + "static/img_award_deloitte_fast_500_b-ee1a16b1f291faea26ee725e9bbd117e.svg";